import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { AuthService } from 'app/core/services/auth.service';
import { HttpHeaderModel } from 'app/core/services/http-header-model';
import { HttpHeaderService } from 'app/core/services/http-header.service';
import { LocalStorageService } from 'app/core/services/local-storage.service';
import { CustomerAreaMessageService } from 'app/core/services/prothesis-customer-api/pub/customer-area-message.service';
import { Area } from 'app/shared/enums/area.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatCardContent } from '@angular/material/card';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-customer-area-message-banner',
  styleUrls: ['./customer-area-message-banner.component.scss'],
  templateUrl: './customer-area-message-banner.component.html',
  imports: [MatCardContent, NgClass, MatIcon, MatIconButton, MatTooltip],
})
export class CustomerAreaMessageBannerComponent implements OnInit {
  public static strKeyCustomerAreaMessageClosed = 'customer-area-message-closed';
  public customerAreaMessageClosed: number;
  public displayFlag: boolean;
  public etag: number | null;
  public etagFromHttpHeader: number | null | undefined;
  public getInfoCustomerAreaMessageScheduled = false;
  public isAdminOrSuperAdminFlag = false;
  public link: string | null;
  public style: string | null;
  public text: string | null;
  public textLink: string | null;

  private _authService = inject(AuthService);
  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _customerAreamessageService = inject(CustomerAreaMessageService);
  private _httpHeaderService = inject(HttpHeaderService);
  private _localStorageService = inject(LocalStorageService);
  private _unsubscribeAll: Subject<void>;

  public constructor() {
    this._unsubscribeAll = new Subject();
  }

  public close(): void {
    this.displayFlag = false;
    this._localStorageService.write(CustomerAreaMessageBannerComponent.strKeyCustomerAreaMessageClosed, this.etagFromHttpHeader);
  }

  public ngOnInit(): void {
    this._authService.isDoneLoading$.pipe(takeUntil(this._unsubscribeAll)).subscribe((isDoneLoadingFlag) => {
      this._httpHeaderService.onHttpHeaderChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe((httpHeaderModel: HttpHeaderModel) => {
        if (isDoneLoadingFlag) {
          this.isAdminOrSuperAdminFlag = this._authService.isAdminOrSuperAdminFlag;
          this.customerAreaMessageClosed = Number(
            this._localStorageService.read(CustomerAreaMessageBannerComponent.strKeyCustomerAreaMessageClosed),
          );
          this.etagFromHttpHeader = httpHeaderModel?.customerAreaMessageEtag;
          this.displayFlag =
            this.etagFromHttpHeader !== null &&
            this.etagFromHttpHeader !== undefined &&
            this.etagFromHttpHeader !== this.customerAreaMessageClosed &&
            (this._authService.area === Area.Customer || this._authService.area === Area.Admin || this._authService.area === Area.NoArea);

          if (this.etagFromHttpHeader === undefined || this.etagFromHttpHeader === null) {
            this.etag = null;
            this.link = null;
            this.style = null;
            this.text = null;
            this.textLink = null;
          } else if (this.etagFromHttpHeader !== httpHeaderModel?.previousCustomerAreaMessageEtag && this.displayFlag) {
            if (!this.getInfoCustomerAreaMessageScheduled) {
              this.getInfoCustomerAreaMessageScheduled = true;
              this.text = 'Un message est en cours de chargement...';
              setTimeout(() => {
                this._customerAreamessageService.getInfoCustomerAreaMessage().subscribe((res) => {
                  this.etag = res.etag;
                  this.link = res.link;
                  this.style = res.style;
                  this.text = res.text;
                  this.textLink = res.textLink;

                  this.getInfoCustomerAreaMessageScheduled = false;

                  // Mark for check
                  this._changeDetectorRef.markForCheck();
                });
              }, 1000);
            }
          }
        }

        // Mark for check
        this._changeDetectorRef.markForCheck();
      });
    });
  }
}
